import React, { useState } from "react";
import { ReactComponent as Logo } from "../../assets/svgs/sidebarlogo.svg";
import { ReactComponent as Whitelogo } from "../../assets/svgs/Carburn-whitelogo.svg";
import { ReactComponent as PrivacyImg } from "../../assets/svgs/Privacy Policy.svg";
import { ReactComponent as TermsImg } from "../../assets/svgs/Terms and Conditions.svg";
import { ReactComponent as PrivacyTabIcon } from "../../assets/svgs/privacy poilcy.svg";
import { ReactComponent as TermsTabIcon } from "../../assets/svgs/T&C icon.svg";
import LoginC from "../Auth/LoginC";
import SignupC from "../Auth/SignupC";
import ResetPasswords from "../Auth/ResetPasswords";
import ResetPasswordForm from "../Auth/ResetPasswordForm";

const TABS = [
  {
    id: "privacy",
    label: "Privacy Policy",
    icon: <PrivacyTabIcon className="w-5 h-5 fill-current stroke-current" />,
  },
  {
    id: "terms",
    label: "Terms & Conditions",
    icon: <TermsTabIcon className="w-5 h-5" />,
  },
];

const PrivacyContent = () => (
  <div className="text-sm text-gray-700 space-y-4 leading-relaxed">
    <p>
      At Carburn, we respect your privacy and are committed to protecting the
      personal information you share with us. This Privacy Policy explains how
      Carburn collects, uses, stores, and protects information when you visit
      our website, create an account, use our services, or communicate with us.
    </p>
    <p>
      By using Carburn, you acknowledge that you have read and understood this
      Privacy Policy.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      1. Information We Collect
    </h3>
    <p>
      We may collect information that you provide directly to us, information
      generated through your use of our platform, and certain information
      collected automatically.
    </p>

    <p className="font-semibold text-gray-800">
      Personal Information may include:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Name</li>
      <li>Email address</li>
      <li>Phone number</li>
      <li>Company or organisation name</li>
      <li>Job title or designation</li>
      <li>Billing and business information</li>
      <li>Account login information</li>
      <li>Information submitted through forms or service requests</li>
      <li>Any other information you voluntarily provide to us</li>
    </ul>

    <p className="font-semibold text-gray-800 mt-4">
      Usage Information may include:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Pages and features you access</li>
      <li>Your interactions with our website and platform</li>
      <li>Browser and device information</li>
      <li>IP address</li>
      <li>Operating system</li>
      <li>Approximate location information</li>
      <li>Website activity and usage patterns</li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      2. How We Use Your Information
    </h3>
    <p>We may use the information we collect to:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Create and manage your Carburn account.</li>
      <li>Provide, operate, and maintain our services.</li>
      <li>Process requests and enquiries.</li>
      <li>Communicate with you about our services.</li>
      <li>Provide customer support.</li>
      <li>Personalise and improve your experience.</li>
      <li>Understand how users interact with our platform.</li>
      <li>Develop new features, products, and services.</li>
      <li>Monitor platform performance and security.</li>
      <li>
        Detect, prevent, and address fraud, misuse, or security incidents.
      </li>
      <li>Send service-related communications.</li>
      <li>
        Send marketing or promotional communications where permitted by law.
      </li>
      <li>Meet applicable legal and regulatory requirements.</li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      3. Cookies and Similar Technologies
    </h3>
    <p>
      Carburn may use cookies and similar technologies to improve website
      functionality, understand usage patterns, remember preferences, and
      enhance your experience.
    </p>
    <p className="font-semibold text-gray-800">Cookies may be used for:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Essential website functionality</li>
      <li>Authentication and account management</li>
      <li>Analytics and performance measurement</li>
      <li>Website personalisation</li>
      <li>Marketing and communication purposes</li>
    </ul>
    <p>
      You may be able to control or disable cookies through your browser
      settings. Disabling certain cookies may affect the functionality of some
      parts of the website.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      4. How We Share Information
    </h3>
    <p>We do not sell your personal information.</p>
    <p>We may share information where reasonably necessary with:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>
        Service providers and technology partners who support our operations.
      </li>
      <li>Hosting, cloud, analytics, communication, and security providers.</li>
      <li>Professional advisers, auditors, or consultants.</li>
      <li>
        Government authorities or regulatory bodies where required by law.
      </li>
      <li>Business partners where necessary to provide a requested service.</li>
      <li>
        A successor entity in connection with a merger, acquisition,
        restructuring, or transfer of business assets.
      </li>
    </ul>
    <p>
      Where appropriate, we take reasonable steps to ensure that third parties
      handle information in accordance with applicable confidentiality and data
      protection requirements.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      5. Data Security
    </h3>
    <p>
      We take reasonable technical and organisational measures to protect your
      information against unauthorised access, loss, misuse, alteration,
      disclosure, or destruction.
    </p>
    <p>
      However, no method of transmitting or storing information electronically
      can be guaranteed to be completely secure. Therefore, while we work to
      protect your information, we cannot guarantee absolute security.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      6. Data Retention
    </h3>
    <p>
      We retain personal information only for as long as reasonably necessary
      to:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Provide our services.</li>
      <li>Maintain business and transaction records.</li>
      <li>Fulfil the purposes described in this Privacy Policy.</li>
      <li>
        Comply with applicable legal, tax, accounting, and regulatory
        obligations.
      </li>
      <li>Resolve disputes and enforce agreements.</li>
    </ul>
    <p>
      When information is no longer required, we may delete, anonymise, or
      securely dispose of it, subject to applicable legal requirements.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      7. Your Privacy Rights
    </h3>
    <p>
      Depending on applicable law, you may have rights regarding your personal
      information, including the ability to:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Request information about the personal data we process.</li>
      <li>Request correction of inaccurate or incomplete information.</li>
      <li>
        Request deletion of personal information where legally applicable.
      </li>
      <li>Withdraw consent where processing is based on consent.</li>
      <li>Request information regarding the handling of your personal data.</li>
      <li>
        Raise a concern or grievance regarding our processing of your
        information.
      </li>
    </ul>
    <p>
      Requests may be subject to verification and applicable legal limitations.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      8. Third-Party Links
    </h3>
    <p>
      Our website may contain links to third-party websites, applications, or
      services.
    </p>
    <p>
      Carburn is not responsible for the privacy practices, content, security,
      or policies of third-party websites. We recommend reviewing the privacy
      policy of any third-party service you access.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      9. Children's Privacy
    </h3>
    <p>
      Carburn's services are intended primarily for businesses and professional
      users. We do not knowingly collect personal information from children in
      circumstances where such collection is prohibited by applicable law.
    </p>
    <p>
      If you believe that a child has provided personal information to us
      improperly, please contact us so that we can take appropriate action.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      10. Changes to This Privacy Policy
    </h3>
    <p>
      We may update this Privacy Policy from time to time to reflect changes in
      our services, technology, business practices, or applicable laws. When we
      make material changes, we may update the "Last Updated" date and provide
      additional notice where required.
    </p>
  </div>
);

const TermsContent = () => (
  <div className="text-sm text-gray-700 space-y-4 leading-relaxed">
    <p className="font-semibold text-gray-900">Welcome to CARBURN.</p>
    <p>
      These <span className="font-semibold">Terms &amp; Conditions</span> govern
      your access to and use of the CARBURN website, platform, applications, and
      related services. By accessing or using CARBURN, you agree to be bound by
      these Terms &amp; Conditions. If you do not agree with these terms, please
      do not use our services.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      1. About Carburn
    </h3>
    <p>
      Carburn provides digital tools and services designed to help businesses
      understand, manage, and improve their environmental and carbon-related
      activities. The specific services available to you may depend on your
      account, subscription, plan, organisation, or service agreement with
      Carburn.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      2. Eligibility
    </h3>
    <p>
      You must provide accurate and complete information when creating an
      account or using our services.
    </p>
    <p>By using Carburn, you represent that:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>You have the legal capacity to enter into these Terms.</li>
      <li>The information you provide is accurate and current.</li>
      <li>You will use the platform only for lawful purposes.</li>
      <li>
        If you are using Carburn on behalf of an organisation, you have
        appropriate authority to do so.
      </li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      3. Account Registration
    </h3>
    <p>
      Certain Carburn features may require you to create an account. You are
      responsible for:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Maintaining the confidentiality of your login credentials.</li>
      <li>Keeping your account information accurate and updated.</li>
      <li>All activities conducted through your account.</li>
      <li>Immediately informing Carburn if you suspect unauthorised access.</li>
    </ul>
    <p>
      Carburn reserves the right to suspend or restrict accounts where we
      reasonably believe there has been misuse, fraud, unauthorised access, or
      violation of these Terms.
    </p>

    <p className="mt-2">You agree not to:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Use the platform for any unlawful or unauthorised purpose.</li>
      <li>Attempt to gain unauthorised access to any part of the platform.</li>
      <li>Remove or alter any proprietary notices from the platform.</li>
      <li>Sell or transfer your access to CARBURN's platform.</li>
      <li>
        Use automation tools to scrape or extract data without permission.
      </li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      4. User Personal Information
    </h3>
    <p>
      This may initially include the name, operational data, and possibly the
      email, job title, phone number, address or other information required for
      a member to use CARBURN.
    </p>
    <p>
      CARBURN may also administer payments as a service operating relationship,
      such as, to maintain or other matters.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      5. Environments and Listing Information
    </h3>
    <p>
      CARBURN may provide information on activities, scopes, supply and/or to
      the waste when the platform activates this information, availability, and
      requirements.
    </p>
    <p>Information may include but is not be limited to:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Data provided by the user.</li>
      <li>Data to help users meet standards.</li>
      <li>Assumptions and emission factor data.</li>
      <li>
        Regulatory standards, methodology, or regulatory data requirements.
      </li>
    </ul>
    <p>
      Unless scoped otherwise or CARBURN's policy, CARBURN's content can be
      limited to a specific division or otherwise those categorized data.
      Financial details or other relating may require additional verification.
    </p>
    <p>
      Users are responsible for the appropriately attending information either
      explicitly implicitly, or using verified financial resources, or other
      relating to verify input such financial information or other relevant
      matters.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      6. Intellectual Property
    </h3>
    <p>
      All content and materials on this platform, including but not limited to
      CARBURN, are the property of CARBURN or its licensors, unless otherwise
      stated.
    </p>
    <p>This includes:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Site content</li>
      <li>Trademarks and logos</li>
      <li>Possible design</li>
      <li>Reports and sustainability benchmarks</li>
      <li>Methods and tools</li>
      <li>Interfaces and layouts</li>
      <li>Database</li>
      <li>Platform features, tools and designs</li>
      <li>Documentation</li>
      <li>Other proprietary assets</li>
    </ul>
    <p>
      These Terms do not grant any member or to Carburn's intellectual property.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      7. User Content
    </h3>
    <p>
      By submitting information to Carburn, you grant to the platform a
      worldwide, non-exclusive, royalty-free license to use, display, process,
      and store the data as necessary to provide the service and to fulfill
      Carburn's Terms.
    </p>
    <p>
      You remain responsible for ensuring that any data that you input is
      accurate and permitted for submission in these circumstances.
    </p>
    <p>
      Third parties may have their own terms for their particular data,
      analytics, data system or platforms. Users are responsible for the
      responsibility and operate in accordance with such circumstances.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      8. Third-Party Services
    </h3>
    <p>
      Carburn may integrate with third-party services, partners, data systems,
      or platforms. Carburn is not responsible for those services or platforms.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      9. Service Availability
    </h3>
    <p>
      Carburn does not guarantee uninterrupted service or access at all times.
      The service may occasionally be unavailable due to:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Maintenance</li>
      <li>Technical issues</li>
      <li>Service-related communications</li>
      <li>Force majeure circumstances</li>
      <li>Services or tools not currently provided</li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      10. Payment and Subscription
    </h3>
    <p>
      Certain platform features or subscriptions may be subject to a payment.
      Applicable fees will be communicated to you when applicable.
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Fees may be subject to applicable taxes.</li>
      <li>
        Payments shall be processed pursuant to a payment order by, or receipt,
        submitted and agreement, or service or reporting fees.
      </li>
    </ul>
    <p>
      Unless otherwise mentioned, fees and payments may not be refundable except
      in cases of any applicable, or our summary agreed timing.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      11. Cancellation or Termination
    </h3>
    <p>Carburn may suspend access to the platform if:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>You repeatedly breach these or other practices.</li>
      <li>Your activities breach any official jurisdiction or law.</li>
      <li>We are unable to verify your identity or information.</li>
    </ul>
    <p>
      You may discontinue using this service at any time, subject to the refund
      or subscription obligations.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      12. Disclaimer
    </h3>
    <p>
      While it is applicable to the platform's content projects, CARBURN's from
      time is provided "as available" and "as is" basis.
    </p>
    <p>We do not guarantee that:</p>
    <ul className="list-disc pl-5 space-y-1">
      <li>The platform will always be accessible.</li>
      <li>The platform will be error-free.</li>
      <li>
        Information used will meet every specific business or regulatory
        requirements.
      </li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      13. Limitation of Liability
    </h3>
    <p>
      To the maximum extent permitted by applicable law, Carburn will not be
      responsible for indirect, incidental, special, consequential or
      restitutionary arising from or in connection with or for the platform.
    </p>
    <p>
      Nothing in these terms is intended to exclude or limit the User's legal
      rights or remedies under applicable law.
    </p>
    <p>
      If applicable law sets additional limitation of liability to you
      specifically, the accessible limits extend to services on any agreement or
      amendment.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      14. Indemnification
    </h3>
    <p>
      By accessing or using our platform, you agree to defend, indemnify, and
      hold harmless Carburn, its affiliates, successors, officers, and service
      providers from any losses, costs, liabilities, damages, and claims arising
      from:
    </p>
    <ul className="list-disc pl-5 space-y-1">
      <li>Your violation of these terms.</li>
      <li>Information or content you have submitted.</li>
      <li>Infringement of any applicable rights.</li>
    </ul>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      15. No Arbitration
    </h3>
    <p>
      These terms shall be governed and construed in accordance with the laws of
      CARBURN's. Differences should be agreed in writing or assigned by
      applicable law.
    </p>

    <h3 className="font-semibold text-gray-900 text-base mt-6">
      16. Changes to These Terms
    </h3>
    <p>
      We reserve the right to amend these terms from time to time. Significant
      changes shall be communicated and will become effective after the updated
      terms become effective, or for continued users, terms shall be permitted
      in law.
    </p>
  </div>
);

const PoliciesPage = () => {
  const [selectedTab, setSelectedTab] = useState("privacy");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showResetpassword, setShowResetpassword] = useState(false);
  const [showResetPasswordwithmail, setShowResetPasswordwithmail] =
    useState(false);

  const activeTab = TABS.find((t) => t.id === selectedTab);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* ── Public Header ── */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-[96%] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center flex-shrink-0">
              <Logo className="w-36 h-36" />
            </div>

            <nav className="hidden md:flex space-x-8 text-sm font-medium">
              {[
                "Features",
                "How it Works",
                "Testimonials",
                "Pricing",
                "Contact",
              ].map((item) => (
                <a
                  key={item}
                  href="/organization/login"
                  className="text-gray-600 hover:text-[#06513D] transition-colors"
                >
                  {item}
                </a>
              ))}
            </nav>

            <div className="hidden md:flex items-center space-x-2">
              <button
                className="bg-white text-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-sm hover:bg-green-50 transition-colors"
                onClick={() => setShowLogin(true)}
              >
                Log In
              </button>
              <button
                className="text-white bg-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-sm transition-colors hover:bg-[#054a37]"
                onClick={() => setShowSignup(true)}
              >
                Sign Up
              </button>
            </div>

            {/* Mobile hamburger */}
            <div className="md:hidden">
              <button
                className="text-gray-700 hover:text-green-600"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      isMobileMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile panel */}
          {isMobileMenuOpen && (
            <div className="md:hidden fixed inset-0 z-50">
              <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={() => setIsMobileMenuOpen(false)}
              />
              <div className="fixed top-0 right-0 h-full w-72 bg-white shadow-xl">
                <div className="flex justify-between items-center p-4 border-b">
                  <Logo className="w-28 h-28" />
                  <button onClick={() => setIsMobileMenuOpen(false)}>
                    <svg
                      className="h-6 w-6 text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                <nav className="px-4 py-6 space-y-3">
                  {[
                    "Features",
                    "How it Works",
                    "Testimonials",
                    "Pricing",
                    "Contact",
                  ].map((item) => (
                    <a
                      key={item}
                      href="/organization/login"
                      className="block px-3 py-2 text-gray-700 hover:text-green-600"
                    >
                      {item}
                    </a>
                  ))}
                </nav>
                <div className="px-4 space-y-3 border-t pt-4">
                  <button
                    onClick={() => {
                      setIsMobileMenuOpen(false);
                      setShowLogin(true);
                    }}
                    className="w-full bg-white text-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-sm hover:bg-green-50"
                  >
                    Log In
                  </button>
                  <button
                    onClick={() => {
                      setIsMobileMenuOpen(false);
                      setShowSignup(true);
                    }}
                    className="w-full text-white bg-[#06513D] px-4 py-2 rounded-md text-sm hover:bg-[#054a37]"
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* ── Page Body ── */}
      <div className="flex-1 max-w-[96%] mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        {/* Breadcrumb */}
        <div className="text-xs text-gray-400 mb-5 flex items-center gap-1.5">
          <a href="/organization/login" className="hover:text-[#06513D]">
            Home
          </a>
          <span>›</span>
          <span>Policies &amp; Information</span>
          <span>›</span>
          <span className="text-gray-700 font-medium">{activeTab?.label}</span>
        </div>

        {/* Page heading */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">
            Policies &amp; Information
          </h1>
          <p className="text-gray-500 text-sm mt-1">
            Read our policies and information.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 items-start">
          {/* ── Sidebar ── */}
          <div className="w-full lg:w-72 flex-shrink-0 border border-[#06513D] rounded-2xl p-4 bg-white shadow-sm">
            <div className="flex flex-col gap-3">
              {TABS.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setSelectedTab(tab.id)}
                  className={`relative w-full flex items-center gap-3 py-4 pr-4 text-left text-[15px] font-semibold transition-all duration-200 ${
                    selectedTab === tab.id
                      ? "bg-[#E6EDEB] text-[#06513D] rounded-xl border border-[#06513D] overflow-hidden pl-7"
                      : "bg-white text-[#4A5568] hover:bg-gray-50 rounded-xl border border-transparent pl-7"
                  }`}
                >
                  {selectedTab === tab.id && (
                    <div className="absolute left-0 top-0 bottom-0 w-3.5 bg-[#06513D]" />
                  )}
                  <div
                    className={`flex items-center justify-center flex-shrink-0 ${
                      selectedTab === tab.id
                        ? "text-[#06513D]"
                        : "text-[#2d3748]"
                    }`}
                  >
                    {tab.icon}
                  </div>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* ── Content Card ── */}
          <div className="flex-1 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="flex min-h-[600px]">
              {/* Scrollable Text */}
              <div className="flex-1 p-6 lg:p-8 overflow-y-auto max-h-[75vh] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                {selectedTab === "privacy" ? (
                  <PrivacyContent />
                ) : (
                  <TermsContent />
                )}
              </div>

              {/* Fixed Illustration Panel */}
              <div
                className="hidden xl:flex w-96 flex-shrink-0 items-start justify-center p-6 sticky top-20 self-start"
                style={{ minHeight: "85vh" }}
              >
                <div className="flex flex-col items-center justify-center h-full w-full">
                  {selectedTab === "privacy" ? (
                    <PrivacyImg className="w-full max-w-[350px]" />
                  ) : (
                    <TermsImg className="w-full max-w-[350px]" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer — same as logins.jsx */}
      <footer className="bg-gray-900 text-white py-4">
        <div className="max-w-[96%] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 text-sm text-center md:text-left">
            <div>
              <div className="h-15 mb-2">
                <Whitelogo />
              </div>
              <p className="text-gray-300">
                Simplifying ESG reporting and carbon footprint management for a
                sustainable future.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Integrations
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    About
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Community
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-4 flex justify-center items-center text-center text-gray-400 text-sm mt-4">
            <p className="m-0">&copy; 2025 CARBURN. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      {showLogin && (
        <LoginC
          LoginConClose={() => setShowLogin(false)}
          onSignup={() => {
            setShowLogin(false);
            setShowSignup(true);
          }}
          onResetPassword={() => {
            setShowLogin(false);
            setShowResetpassword(true);
          }}
        />
      )}
      {showSignup && (
        <SignupC
          onCloseSignupC={() => setShowSignup(false)}
          onLogin={() => {
            setShowSignup(false);
            setShowLogin(true);
          }}
        />
      )}
      {showResetpassword && (
        <ResetPasswords
          onCloseReset={() => setShowResetpassword(false)}
          onBackToLogin={() => {
            setShowResetpassword(false);
            setShowLogin(true);
          }}
        />
      )}
      {showResetPasswordwithmail && (
        <ResetPasswordForm
          onCloseForm={() => setShowResetPasswordwithmail(false)}
        />
      )}
    </div>
  );
};

export default PoliciesPage;
